import React from 'react';
import { Alert } from '@mui/material';

const NoAccessSection: React.FC = () => {
  return <Alert severity="error">You do not have access to this section.</Alert>;
};

export default NoAccessSection;
